import React from 'react';
import { FDAlert } from '@facet-wealth/design';
import MetaCollectionFormInline from 'Components/UI/Meta/MetaForm/MetaCollectionFormInline';
import PropTypes from 'prop-types';
import {
  Layout as AccountItem,
  metaOverrideSet as nextUpAccountItemMetaOverrideSet,
} from './AccountItem';

const AccountItems = ({ collection }) => {
  if (collection.resources().length() === 0) {
    return (
      <FDAlert
        title="No accounts to open and fund."
        status={'info'}
      />
    );
  }

  return (
    <MetaCollectionFormInline
      padding="none"
      collection={collection}
      FormProps={{
        layout: AccountItem,
        noIndividualSubmitButtons: true,
      }}
      metaOverrideSet={nextUpAccountItemMetaOverrideSet}
    />
  );
};

AccountItems.defaultProps = {
};

AccountItems.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default AccountItems;
